<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>ROI2</span>
        </div>
        <el-form ref="queryForm" :model="queryParams" :inline="true">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <el-button type="primary" :loading="loading" icon="el-icon-download" size="mini" @click="exportData">导出</el-button>
          </el-form-item>
        </el-form>
        <div ref="chartContainer" style="width: 100%; height: 400px;" />

      </el-card>
      <el-card>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="date"
            label="日期"
            width="120px"
            align="center"
          />
          <el-table-column
            prop="ad"
            label="广告花费"
            align="center"
          >
            <template scope="scope">
              <span v-if="!scope.row.edit" @click="handleAdPrice(scope.$index)">
                <i
                  style="color:#409EFF"
                  class="el-icon-edit"
                /> {{ scope.row.ad }}
              </span>
              <span v-else>
                <el-input
                  v-model="scope.row.ad"
                  size="small"
                  @blur="saveAdPrice(scope.$index, scope.row.ad)"
                />
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="渠道前流水"
            align="center"
          >
            <el-table-column
              prop="google_price"
              label="谷歌流水"
              align="center"
            />
            <el-table-column
              prop="apple_price"
              label="苹果流水"
              align="center"
            />
          </el-table-column>
          <el-table-column
            label="渠道后流水"
            align="center"
          >
            <el-table-column
              prop="google_profit"
              label="谷歌流水"
              align="center"
            >
              <template slot="header">
                <el-popover
                  placement="top-start"
                  width="260"
                  trigger="hover"
                  content="金额=渠道前金额*85%"
                >
                  <span slot="reference">谷歌流水 <i class="el-icon-warning-outline" /></span>
                </el-popover>
              </template>
              <template scope="scope">{{ scope.row.google_profit }}</template>
            </el-table-column>
            <el-table-column
              prop="apple_profit"
              label="苹果流水"
              align="center"
            >
              <template slot="header">
                <el-popover
                  placement="top-start"
                  width="260"
                  trigger="hover"
                  content="金额=渠道前金额*70%"
                >
                  <span slot="reference">苹果流水 <i class="el-icon-warning-outline" /></span>
                </el-popover>
              </template>
              <template scope="scope">{{ scope.row.apple_profit }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            prop="price"
            label="内购"
            align="center"
          />
          <el-table-column
            prop="ad_realise"
            label="广告变现"
            align="center"
          />
          <el-table-column
            prop="profit"
            label="毛利合计"
            align="center"
          />
          <el-table-column
            label="当日ROI"
            align="center"
          >
            <template slot="header">
              <el-popover
                placement="top-start"
                width="260"
                trigger="hover"
                content="当日ROI=毛利合计/广告花费*100"
              >
                <span slot="reference">当日ROI <i class="el-icon-warning-outline" /></span>
              </el-popover>
            </template>
            <template scope="scope">{{ scope.row.roi }}%</template>
          </el-table-column>
        </el-table>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getRoi2, handleRoi } from '@/api/statistics/user_remain'
import echarts from 'echarts'
import { getCacheQuery, getLastDates, setCacheQuery } from '@/utils'
import { isNumeric } from 'echarts/lib/util/number'

export default {
  name: 'ROI',
  data() {
    return {
      chartData: {},
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        country: '',
        platForm: 0,
        type: 0
      },
      country: [],
      loading: false,
      options: [],
      tableData: [],
      tableData2: [],
      date: [],
      chart: {},
      option: {}
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }
    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(1)
    }
    this.getTables(undefined)
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    handleKeyUp() {
      this.onSubmit()
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      this.getTables({})
    },
    getTables(event) {
      this.queryParams.type = 0
      this.loading = true
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getRoi2(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        this.loading = false
        if (res.code === 200) {
          for (const i in res.data.data) {
            res.data.data[i].edit = false
          }
          this.tableData = res.data.data
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
          const country = res.data.country
          this.country = [{ value: '', label: '全部' }]
          for (const i in country) {
            this.country.push({ value: country[i], label: country[i] })
          }
          const data = []
          this.date = []

          res.data.data.forEach((res, index) => {
            this.date.push(res.date)
            data.push(res.roi)
          })

          this.option.xAxis.data = this.date
          this.option.series[0].data = data
          this.chart.setOption(this.option)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    numFormatter(row, column, cellValue, index) {
      return cellValue + '%'
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          // text: 'ROI'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          // data: ['次日', '3日', '7日', '15日', '30日'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true,
          feature: {
            // dataView: { readOnly: false },
            // magicType: { type: ['line', 'bar'] },
            // restore: {},
            // saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            // name: '次日',
            data: [],
            type: 'line',
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    handleAdPrice(idx) {
      this.tableData[idx].edit = true
    },
    saveAdPrice(idx, adPrice) {
      this.tableData[idx].edit = false
      if (!isNumeric(adPrice)) {
        this.tableData[idx].ad = 0
        this.msgError('输入的金额有误！')
        return
      }
      if (adPrice <= 0) {
        this.msgError('广告花费不能小于0！')
        return
      }
      const data = this.tableData[idx]
      handleRoi({ startDate: data.date, lang: adPrice }).then(res => {
        this.getTables()
      })
    },
    exportData() {
      this.queryParams.type = 1
      getRoi2(this.queryParams).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
